import {
	createDetailsSaveRegistry,
	type DetailsCommitResult,
	type DetailsSaveController,
} from "@/features/entity-details";

export type JobDetailsEditableField = "name" | "status" | "description";

export type JobDetailsCommitResult =
	DetailsCommitResult<JobDetailsEditableField>;

export type JobDetailsSaveController =
	DetailsSaveController<JobDetailsEditableField>;

const registry = createDetailsSaveRegistry<JobDetailsEditableField>();

/**
 * Provides a registerable save controller for Job Details autosave + nav guards.
 */
export const JobDetailsSaveProvider = registry.Provider;

/**
 * Access the Details save registry (null outside provider).
 */
export const useJobDetailsSaveRegistry = registry.useRegistry;

/**
 * Latest registered controller, or null when Details panel is unmounted.
 */
export const useJobDetailsSaveController = registry.useController;
